<template>
  <card>
    <div class="container">
      <div class="row">
        <div class="col-sm-8">
          <div class="row">
            <div class="col-sm-8">
              <el-select
                class="select-info"
                size="large"
                placeholder="Single Select"
                v-model="dropDownDisplay.value"
                @change="tableNumber=''"
              >
                <el-option
                  v-for="option in dropDownData"
                  class="select-info"
                  :value="option.value"
                  :label="option.text"
                  :key="option.value"
                ></el-option>
              </el-select>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-9">
              <div class="row">
                <label class="col-sm-4 col-form-label">請輸入桌號</label>
                <div class="col-sm-8">
                  <fg-input placeholder="桌號" v-model="tableNumber"></fg-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-4 col-form-label">圖片大小(pixel)</label>
                <div class="col-sm-8">
                  <fg-input placeholder="size" v-model="size"></fg-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-4 col-form-label">Web版本</label>
                <div class="col-sm-8">
                  <el-select
                    class="select-secondary"
                    size="small"
                    placeholder="Single Select"
                    v-model="webVerSelect.value"
                    @change="tableNumber=''"
                  >
                    <el-option
                      v-for="option in webVerData"
                      class="select-info"
                      :value="option.value"
                      :label="option.text"
                      :key="option.value"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="col-sm-3">
              <n-button type="primary" round @click.native="appendQRCode">產生QR code</n-button>
            </div>
            <div class="col-sm-3" v-if="user.type === 'eaa'">
              <n-button native-type="button" type="gray" @click.native="home()">回商店列表</n-button>
            </div>
          </div>
        </div>

        <div class="col-sm-4">
          <card>
            <h3 class="card-title">批次匯入桌號</h3>

            <div class="row">
              <div class="col-sm-6">
                <el-upload
                  class="file"
                  action=""
                  accept=".xlsx"
                  :on-change="fileOnChange"
                  :auto-upload="false"
                  :show-file-list="false"
                >
                <n-button type="default" round >
                  <i class="now-ui-icons arrows-1_cloud-upload-94"></i>
                  上傳Excel檔案
                </n-button>
                </el-upload>
              </div>
              <p class="text-muted"
              style="position:relative;
              top: 20px;
              right: 10px;">
                {{ fileNameDisplay }}
              </p>
            </div>
            <n-button type="primary" @click.native="batchInsertQrcode()">匯入1.0</n-button>
            <n-button type="primary" @click.native="batchInsertQrcode(2)">匯入2.0</n-button>
            <n-button type="primary" @click.native="batchInsertQrcode(3)">匯入3.0</n-button>
            <n-button type="info" @click.native="downloadExample()">範例下載</n-button>
          </card>
          <card>
            <h3 class="card-title">批次匯出桌號</h3>
            <n-button type="primary" @click.native="downloadBatchExcel()">下載 Excel</n-button>
            <n-button type="primary" @click.native="downloadBatch()">下載桌牌</n-button>
          </card>
        </div>
      </div>

      <div v-show="dropDownDisplay.value == 'toGo'">
         
        <div class="row">
          <div class="col-md-12">
            <card>
              <div class="table-shopping">
                <el-table style="width: 100%" v-loading="loading" :data="toGoQrcode">
                  <el-table-column min-width="220">
                    <div slot-scope="{row}">
                      <a :id="'togo_' + row.tableNumber" :download="generateImageName(tableNumber)" :href="generateImageLink(row.tableNumber, row.link)" title="image">
                        <img :src="generateImageLink(row.tableNumber, row.link)">
                      </a>
                      <qrcode-vue :value="row.link" :size="size" level="H" download v-show="false"></qrcode-vue>
                      <a :id="'_togo_' + row.tableNumber" :download="row.tableNumber + '.png'" v-show="false">
                      </a>
                    </div>
                  </el-table-column>
                  <el-table-column min-width="180" label="桌號" prop="tableNumber"></el-table-column>
                  <el-table-column min-width="180" label="網址">
                    <div slot-scope="{row}">
                      {{row.link}}
                      <br>
                        <input type="hidden" :id="row.tableNumber+'-togo-link'" :value="row.link" style="">
                    </div>
                  </el-table-column>
                  <el-table-column min-width="100" label="WEB版本">
                    <template slot-scope="{row}">
                      {{ getWebVersion(row.endpoint) }}
                    </template>
                  </el-table-column>
                  <el-table-column min-width="100" label="#">
                    <template slot-scope="{row}">
                      <button @click="del(row.id)">刪除</button>
                      <button type="button" @click="downloadTogo(row.tableNumber)">下載</button>
                      <button type="button" @click="downloadOriginTogo(row.tableNumber)">下載QR code</button>
                      <!-- <button type="button" @click="toGoCopy(row)">複製連結</button> -->
                      <button type="button" @click="copy(row)">複製連結</button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </card>
          </div>
        </div>
      </div>

      <div v-show="dropDownDisplay.value == 'eatIn'">
        <!-- <div class="row">
          <div class="col-sm-6">
            <div class="row">
              <label class="col-sm-4 col-form-label">請輸入桌號</label>
              <div class="col-sm-8">
                <fg-input placeholder="桌號" v-model="tableNumber"></fg-input>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-4 col-form-label">圖片大小(pixel)</label>
              <div class="col-sm-8">
                <fg-input placeholder="size" v-model="size"></fg-input>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <n-button type="primary" round @click.native="appendQRCode">產生QR code</n-button>
          </div>
          <div class="col-sm-2">
            <n-button native-type="button" type="gray" @click.native="home()">回商店列表</n-button>
          </div>
        </div> -->
        <div class="row">
          <div class="col-md-12">
            <card>
              <div class="table-shopping">
                <el-table style="width: 100%" v-loading="loading" :data="qrData">
                  <el-table-column min-width="220">
                    <div slot-scope="{row}">
                      <a :id="'eatin_' + row.tableNumber" :download="generateImageName(tableNumber)" :href="generateImageLink(row.tableNumber, row.link)" title="image">
                        <img :src="generateImageLink(row.tableNumber, row.link)">
                      </a>
                      <qrcode-vue :value="row.link" :size="size" level="H" download v-show="false"></qrcode-vue>
                      <a :id="'_eatin_' + row.tableNumber" :download="row.tableNumber + '.png'" v-show="false">
                      </a>
                    </div>
                  </el-table-column>
                  <el-table-column min-width="180" label="桌號" prop="tableNumber"></el-table-column>
                  <el-table-column min-width="180" label="網址">
                    <div slot-scope="{row}">
                      {{row.link}}
                      <br>
                        <input type="hidden" :id="row.tableNumber+'-eatin-link'" :value="row.link" style="">
                    </div>
                  </el-table-column>
                  <el-table-column min-width="100" label="WEB版本">
                    <template slot-scope="{row}">
                      {{ getWebVersion(row.endpoint) }}
                    </template>
                  </el-table-column>
                  <el-table-column min-width="100" label="#">
                    <template slot-scope="{row}">
                      <button @click="del(row.id)">刪除</button>
                      <button type="button" @click="downloadEatIn(row.tableNumber)">下載</button>
                      <button type="button" @click="downloadOriginEatIn(row.tableNumber)">下載QR code</button>
                      <button type="button" @click="copy(row)">複製連結</button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </card>
          </div>
        </div>
      </div>
      
    </div>
  </card>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import {
  Checkbox,
  Radio,
  Switch,
  FormGroupInput as FgInput
} from "src/components/index";
import { Pagination } from "src/components";
import { Table, TableColumn, Select } from "element-ui";
import swal from "sweetalert2";
import moment from "moment-timezone";
import { fetchQrcode, getExcelJson } from "src/javascripts/generalPages/fetchData";
import { insertQrcode, toShortUrl, excelUpload } from "src/javascripts/generalPages/postData";
import { deleteQrcode } from "src/javascripts/generalPages/deleteData";
import { Modal } from 'src/components';
import {
  updateBusiness,
} from "src/javascripts/generalPages/updateForConsoleLog";

var type;
export default {
  beforeRouteEnter(to, from, next) {
    let id = to.params.id;
    type = to.params.type;
    fetchQrcode(id, type)
      .then(res => {
        next(vm => vm.setData(res.data));
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  data() {
    return {
      toGoQrcode: [],
      dropDownDisplay: {
        value: 'eatIn',
        text: '內用'
      },
      dropDownData: [{value: 'eatIn', text: '內用'}, {value: 'toGo', text: '外帶'}],
      webVerSelect: {
        value: '1',
        text: 'QC1.0'
      },
      webVerData: [{value: '1', text: 'QC1.0'}, {value: '2', text: 'Web2.0'}, {value: '3', text: '後結QR'}],
     // webVerData: [{value: '2', text: 'Web2.0'}, {value: '3', text: '後結QR'}],
      type: ['', 'info', 'success', 'warning', 'danger'],
      qrData: [],
      fileNameDisplay: '選擇檔案',
      tableQrcodeBatchData: "",
      accountId: "",
      size: 200,
      tableNumber: "",
      value: "",
      shopId: "",
      localizationSettings: null,
      loading: false
    };
  },
  components: {
    QrcodeVue,
    [Pagination.name]: Pagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    [Select.name]: Select
  },
  computed: {
    user: function() {
      return this.$store.getters.user;
    },
    userType: function() {
      return this.$store.getters.userType;
    }
  },
  methods: {
    downloadBatchExcel() {
      window.open(`${process.env.VUE_APP_APIHOST}/${type}/shops/${this.shopId}/qrcode-excel`);
    },
    downloadBatch() {
      window.open(`${process.env.VUE_APP_APIHOST}/${type}/shops/${this.shopId}/qrcode-table`);
    },
    generateImageLink(tableNumber, link) {
      if (tableNumber)
        return `https://qrpay.tw/merchants/tingtest/posm/table?url=${link}&tableNo=${tableNumber}`;
      else 
        return `https://qrpay.tw/merchants/tingtest/posm/table?url=${link}`;
      
    },
    generateImageName(tableNumber) {
      if (tableNumber) {
        return `${tableNumber}.png`;
      } else {
        const filename = Date.now();
        return `${filename}.png`
      }
    },
    setData(data) {
      this.toGoQrcode = data.toGoQrcode;
      this.qrData = data.qrcode;
      this.shopId = data.shopId;
      if (!data || !data.localizationSettings) {
        this.localizationSettings = { mealSettings: { tableRequired: false } }
      } else {
        this.localizationSettings = data.localizationSettings;
        if (!this.localizationSettings.mealSettings) {
          this.localizationSettings.mealSettings = { tableRequired: false };
        } else if (!this.localizationSettings.mealSettings.tableRequired) {
          this.localizationSettings.mealSettings.tableRequired = false;
        }
      }
    },
    appendQRCode: async function () {
      const isTableRequired = this.dropDownDisplay.value === "eatIn" ? true : false; 
      if (isTableRequired && this.duplicate()) {
        swal.fire("桌號重複");
      } else if(isTableRequired && !this.isExist()) {
        swal.fire("桌號不能空白");
      } else {
        let data = [{
          tableNumber: this.tableNumber,
          qrType: this.dropDownDisplay.value,
          webVersion: this.webVerSelect.value
        }];
        await insertQrcode(data, type, this.shopId)
          .then(res => {
            // let qrData = {
            //   endpoint: res.data.results.endpoint,
            //   accountId: res.data.results.accountId,
            //   // token: res.data.results.token,
            //   tableNumber: this.tableNumber
            // };
            this.accountId = res.data.results[0].accountId
            let obj = Object.assign(
              {},
              {
                tableNumber: res.data.results[0].tableNumber,
                id: res.data.results[0].insertQrcodeRes.insertId,
                endpoint: res.data.results[0].endpoint,
                accountId: res.data.results[0].accountId,
                link: res.data.results[0].link, 
                type: res.data.results[0].qrType
                // token: res.data.results.token
              }
            );
            if (res.data.results[0].qrType == 'toGo'){
              this.$set(this.toGoQrcode, this.toGoQrcode.length, obj);
            } else {
              this.$set(this.qrData, this.qrData.length, obj);
            }
            // this.$set(this.qrData, this.qrData.length, obj);
            this.tableNumber = "";
          })
          .catch((err) => {
            console.log("err: ", err);
          });

        if (this.localizationSettings.mealSettings.tableRequired !== true) {
          this.localizationSettings.mealSettings.tableRequired = true;
          let updateBooleanData = {
            key: "localization_settings",
            value: JSON.stringify(this.localizationSettings),
            dbTable: "business",
            label: "桌號強制輸入",
            type: "content",
          };

          try {
            await updateBusiness(updateBooleanData, this.accountId, this.userType);
          } catch (error) {
            this.localizationSettings.mealSettings.tableRequired = false;
            console.error("更新失敗: tableRequired 設置為 false", error);
          }
        } else {
          console.log("tableRequired 已經是 true，無需更新");
        }
      }
    },
    // appendToGoQRCode: function() {
    //   let data = {
    //     shopId: this.shopId,
    //     tableNumber: "none",
    //     qrType: this.dropDownDisplay.value
    //   };
    //   insertQrcode(data, type)
    //     .then(res => {
    //       // let qrData = {
    //       //   endpoint: res.data.results.endpoint,
    //       //   accountId: res.data.results.accountId,
    //       //   // token: res.data.results.token,
    //       //   tableNumber: this.tableNumber
    //       // };
    //       let obj = Object.assign(
    //         {},
    //         {
    //           tableNumber: "none",
    //           id: res.data.results.insertQrcodeRes.insertId,
    //           endpoint: res.data.results.endpoint,
    //           accountId: res.data.results.accountId,
    //           link: res.data.results.link,
    //           type: 'toGo'
    //           // token: res.data.results.token
    //         }
    //       );
    //       this.$set(this.toGoQrcode, this.toGoQrcode.length, obj);
    //       this.tableNumber = "";
    //       console.log("this.toGoQrcode: ", this.toGoQrcode)
    //     })
    //     .catch(err => {
    //       console.log("err: ", err);
    //     });
    // },
    duplicate() {
      if (this.dropDownDisplay.value == 'toGo') {
        return this.toGoQrcode.some(d => d.tableNumber === this.tableNumber);
      } else {
        return this.qrData.some(d => d.tableNumber === this.tableNumber);
      }
    },
    isExist() {
      return this.tableNumber ? true : false;
    },
    downloadEatIn(tableNumber) {
      this.$el.querySelector("#eatin_" + tableNumber).click();
    },
    downloadTogo(tableNumber) {
      this.$el.querySelector("#togo_" + tableNumber).click();
    },
    downloadOriginEatIn(tableNumber) {
      let a = this.$el.querySelector("#_eatin_" + tableNumber);
      let parentNode = a.parentNode;
      let canvas = parentNode.getElementsByTagName("canvas")[0];
      let img = canvas.toDataURL("image/png");
      a.setAttribute("href", img);
      a.click();
    },
    downloadOriginTogo(tableNumber) {
      let a = this.$el.querySelector("#_togo_" + tableNumber);
      let parentNode = a.parentNode;
      let canvas = parentNode.getElementsByTagName("canvas")[0];
      let img = canvas.toDataURL("image/png");
      a.setAttribute("href", img);
      a.click();
    },
    copy(row) {
      // let textToCopy = document.querySelector(`#${row.tableNumber}-eatin-link`);
      // textToCopy.setAttribute('type', 'text');
      // textToCopy.select();
      // var successful = document.execCommand("copy");
      // if(successful){
      //   swal.fire(`內用連結${row.tableNumber}已複製`)
      // }
      // textToCopy.setAttribute('type', 'hidden');
      if (!row.link) {
        swal.fire(`無連結可複製。`);
        return;
      }
      navigator.clipboard.writeText(row.link)
      .then(() => {
        //TODO: Alert about the successful copy.
        swal.fire(`已複製連結剪貼簿！`);
      })
      .catch(err => {
        //TODO: Alert about the failed copy.
      });
    },
    toGoCopy(row) {
      let textToCopy = document.querySelector(`#${row.tableNumber}-togo-link`);
      textToCopy.setAttribute('type', 'text');
      textToCopy.select();
      var successful = document.execCommand("copy");
      if(successful){
        swal.fire(`外帶連結已複製`)
      }
      textToCopy.setAttribute('type', 'hidden');

    },
    home: function() {
       window.history.back();
      //this.$router.push({ path: `/${type}/business` });
    },
    del(qrcodeId) {
      deleteQrcode(qrcodeId, type)
        .then(res => {
          if (this.dropDownDisplay.value == 'toGo') {
            let index = this.toGoQrcode.findIndex(element => {
              return element.id === qrcodeId;
            });
            this.toGoQrcode.splice(index, 1);
          }else {
            let index = this.qrData.findIndex(element => {
              return element.id === qrcodeId;
            });
            this.qrData.splice(index, 1);
          }
          
        })
        .catch(err => {
          console.log("err: ", err);
        });
    },
    async fileOnChange(file) {
      try {

        let data = new FormData();
        data.append('excel', file.raw);

        let res = await excelUpload(data);
        let file_id = res.data.file_id;
        res = await getExcelJson(file_id);

        this.tableQrcodeBatchData = res.data;
        this.excelFormatChecking();
        

        this.fileNameDisplay = file.name;
      } catch (error) {
        console.log(error);
        if (error.data) error = error.data;

        this.tableQrcodeBatchData = "";
        this.fileNameDisplay = "選擇檔案";
        if (error.message_TW) {
          swal.fire(error.message_TW);
        } else if (error.message) {
          swal.fire(error.message);
        } else {
          swal.fire('上傳失敗');
        }
      } 
    },
    excelFormatChecking() {
      if (this.tableQrcodeBatchData.sheetNames.length === 0) {
        throw { message: '找不到工作表' }
      }

      let sheet = this.tableQrcodeBatchData.sheets[0];
      if (sheet.data.length > 100) {
        throw { message: '資料太多了(上限100)' }
      }
      for (let data of sheet.data) {
        if (!data['桌號']) {
          throw { message: '缺少"桌號"欄' }
        }
        if (!data['用餐方式']) {
            throw { message: '缺少"用餐方式"欄' }
        }

        if (data['用餐方式'] === 'toGo') {
          this.duplicatePatch(this.toGoQrcode, data['桌號']);
        } else {
          this.duplicatePatch(this.qrData, data['桌號']);
        }
      }
    },
    async batchInsertQrcode(webVersion) {
      if (!this.tableQrcodeBatchData) return;
      this.loading = true;

      let data = [];
      
      for (let tableData of this.tableQrcodeBatchData.sheets[0].data) {
        data.push({
          tableNumber: tableData['桌號'],
          qrType: tableData['用餐方式'],
        })
      }

      let res = await insertQrcode(data, type, this.shopId, webVersion);

      for (let resTableData of res.data.results) {
        let obj = Object.assign(
          {},
          {
            tableNumber: resTableData.tableNumber,
            id: resTableData.insertQrcodeRes.insertId,
            endpoint: resTableData.endpoint,
            accountId: resTableData.accountId,
            link: resTableData.link, 
            type: resTableData.qrType
            // token: res.data.results.token
          }
        );
        if (resTableData.qrType == 'toGo') {
          if (this.duplicatePatch(this.toGoQrcode, obj)) continue;
          this.$set(this.toGoQrcode, this.toGoQrcode.length, obj);
        }else {
          if (this.duplicatePatch(this.qrData, obj)) continue;
          this.$set(this.qrData, this.qrData.length, obj);
        }
      }

      this.tableQrcodeBatchData = "";
      this.fileNameDisplay = "選擇檔案";
      this.loading = false;
      swal.fire('桌號批次匯入成功');
    },
    downloadExample() {
      window.open(`${process.env.VUE_APP_APIHOST}/${type}/qrcode-example`);
    },
    duplicatePatch(qrCodeList, tableNumber) {
      for (let qrCode of qrCodeList) {
        if (tableNumber === qrCode.tableNumber) {
          throw { message: '桌號重覆' }
        }
      }
    },
    getWebVersion(endpoint) {
      return endpoint.startsWith("https://liff") 
      ? 'QC1.0' 
      : endpoint.startsWith("https://order") 
      ? 'WEB2.0' 
      : '後結QR'
    }
  }
  // watch:{
  //   "dropDownDisplay.value": function(val, old) {
  //     console.log("val: ", val);
  //     console.log("old: ", old);
  //     if(val == 'toGo') {
  //       if(this.toGoQrcode.length == 0) {
  //         this.appendToGoQRCode();
  //       }
  //     }
  //   }
  // }
};
</script>
